export default {"src":"/_next/static/media/water-reduction.4d02bb5c.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};